import { useCallback } from 'react';

import { ModalConfirmButton, ValidateFormEventInterceptor } from '@dreryk/react-components';

import { entitlementStatementsTranslationKeys } from '../../../translations';
import { useCreatePatientEntitlementStatement } from '../../PatientEntitlementStatement.hooks';
import { PatientEntitlementStatementCreateFormController } from '../form/PatientEntitlementStatementCreateForm';

import { DatesShowModalEventInterceptor } from './DatesShowModalEventInterceptor';

type PatientModalConfirmationButtonProps = Pick<
   PatientEntitlementStatementCreateFormController,
   'handleSubmit' | 'trigger'
> & {
   readonly patientId: number;
   readonly differentDates: boolean;
   readonly onDataChanged: VoidFunction;
   readonly setEntitlementStatementId: (id: number) => void;
};

export const PatientModalConfirmationButton = ({
   handleSubmit,
   trigger,
   patientId,
   differentDates,
   onDataChanged,
   setEntitlementStatementId,
}: PatientModalConfirmationButtonProps): JSX.Element => {
   const { executeAsync: createPatientEntitlementStatement } = useCreatePatientEntitlementStatement(
      patientId,
      onDataChanged
   );

   const handleClick = useCallback(async (): Promise<void> => {
      await handleSubmit(async (formData) => {
         const id = await createPatientEntitlementStatement(formData);
         setEntitlementStatementId(id);
      })();
   }, [createPatientEntitlementStatement, handleSubmit, setEntitlementStatementId]);

   return (
      <ValidateFormEventInterceptor trigger={trigger}>
         <DatesShowModalEventInterceptor differentDates={differentDates}>
            <ModalConfirmButton
               label={entitlementStatementsTranslationKeys.createModal.confirmButton}
               onClick={handleClick}
            />
         </DatesShowModalEventInterceptor>
      </ValidateFormEventInterceptor>
   );
};
